import _classCallCheck from '@babel/runtime/helpers/esm/classCallCheck';
import _createClass from '@babel/runtime/helpers/esm/createClass';
import _defineProperty from '@babel/runtime/helpers/esm/defineProperty';
import { safeCall } from '@elliemae/ds-utilities/utils';

var VolatileRowsListener = /*#__PURE__*/function () {
  function VolatileRowsListener() {
    _classCallCheck(this, VolatileRowsListener);

    _defineProperty(this, "observers", []);
  }

  _createClass(VolatileRowsListener, [{
    key: "observe",
    value: function observe(listener) {
      this.observers.push(listener);
    }
  }, {
    key: "notify",
    value: function notify(nextRows) {
      this.observers.forEach(function (observer) {
        return safeCall(observer, nextRows);
      });
      this.observers = [];
    }
  }]);

  return VolatileRowsListener;
}();

export default VolatileRowsListener;
//# sourceMappingURL=VolatileRowsListener.js.map
